export default "<label class=\"sura-checkbox\">\n  <input matRipple [checked]=\"checked\" type=\"checkbox\">\n  <span>{{label}}</span>\n</label>";